import React, { PureComponent, Fragment } from 'react';
import PropTypes from 'prop-types';
import { Placeholder } from '@codex/basics';
import { EnvironmentThemeProvider } from '@codex/themes';
import { fetchUserEligibilityCheckData } from '../../../appState/ducks/network';
import ResultAttachment from './ResultAttachment';
import EligibilityCheckLoader from './EligibilityCheckLoader';
import { hidePageWrapper, showPageWrapper } from '../PageWrapper';
import productIdStorage from './helpers/productIdStorage';

const mock = require('./mocks/splittedMock');

class LoadResultAttachment extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      data: null,
      failResponseStatus: null,
      timeoutError: false,
      loader: true
    };

    this.toggleEligibilityCheckLoader = this.toggleEligibilityCheckLoader.bind(this);
  }

  componentDidMount() {
    const userEligibilityCheckId = '1b7e7b01-0337-4074-b557-ee0dc3deedea';
    fetchUserEligibilityCheckData(userEligibilityCheckId, productIdStorage.load())
      .then((resultData) => this.handleResultDataLoaded(resultData))
      .catch((err) => err && this.setState({ failResponseStatus: err.response.status }));
    hidePageWrapper();
  }

  handleResultDataLoaded(resultData) {
    this.setState({ data: resultData });
    productIdStorage.remove();
  }

  hideEligibilityCheckLoader() {
    showPageWrapper();
    this.setState({ loader: false });
  }

  toggleEligibilityCheckLoader() {
    this.setState((state) => ({ loader: !state.loader }));
    if (this.state.loader) {
      showPageWrapper();
    } else {
      hidePageWrapper();
    }
  }

  render() {
    const roundedFailResponseStatus = Math.round(this.state.failResponseStatus / 100) * 100;
    const FailedResultAttachment = () => (roundedFailResponseStatus === 500
      ? <ResultAttachment {...mock[5]} />
      : (
        <Placeholder
          withImage
          withContent
          animated
          randomLineWidth
          numberOfLines={4}
        />
      ));

    return (
      <EnvironmentThemeProvider>
        <>
          {this.state.loader &&
            <EligibilityCheckLoader loader={this.toggleEligibilityCheckLoader} />}
          {!this.state.timeoutError && this.state.data
            ? <ResultAttachment {...this.state.data} />
            : <FailedResultAttachment />}
        </>
      </EnvironmentThemeProvider>
    );
  }
}

LoadResultAttachment.displayName = 'LoadResultAttachment';

LoadResultAttachment.propTypes = {
  children: PropTypes.element.isRequired
};

export default LoadResultAttachment;
